import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

import { DateTimePickerProps } from './DateTimePicker.props';
import { StyledDateTimePicker } from './DateTimePicker.styles';
import { SizeProps } from '../../../@types';

export const DateTimePicker: React.FC<DateTimePickerProps> = ({
  label = 'DateTime',
  disabled = false,
  disableFuture = false,
  disablePast = false,
  value,
  error = false,
  onChange,
  isFocused = false,
  isCompact = false
}) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    setOpen(isFocused);
  }, [isFocused]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StyledDateTimePicker
        label={label}
        isCompact={isCompact}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        disabled={disabled}
        format="YYYY-MM-DD HH:mm"
        disableFuture={disableFuture}
        disablePast={disablePast}
        maxDateTime={disableFuture ? dayjs() : undefined}
        minDateTime={disablePast ? dayjs() : undefined}
        value={dayjs(value, 'YYYY-MM-DD HH:mm')}
        onChange={(text: any) => onChange(text?.format('YYYY-MM-DD HH:mm') || '')}
        slotProps={{
          textField: {
            size: SizeProps.Small,
            fullWidth: true,
            error: error,
            InputProps: {
              placeholder: label
            },
            InputLabelProps: {
              shrink: true
            }
          }
        }}
      />    
    </LocalizationProvider>  
  );
};